import { Button, Image } from 'react-bootstrap'
import ImgVehicleMobile from '../../assets/images/car/vehcile-mobile.svg'

import ServicesMobile from './Services.mobile'
import PhotosMobile from './Photo.mobile'
import { numberFormatCurrency } from '../../utils/helpers'
import { getCarInfo, getServiceLines } from '../../utils/invoice'

const ViewMobile = ({ vehicle, onShowPhoto }) => {
  const { image, year = '', vin = '', stock = '', total = 0, serviceLines = {} } = vehicle
  return (
    <div className='mx-4 shadow mt-3'>
      <div className='py-4 px-3'>
        <div className='d-flex'>
          <Image style={{ width: '20%', objectFit: 'contain' }} src={image || ImgVehicleMobile} />
          <div className='flex-grow-1 ms-2'>
            <div className='d-flex justify-content-between fs-base'>
              <span>{year}</span>
              <span className='fw-600'>{numberFormatCurrency('usd', total)}</span>
            </div>
            <strong>{getCarInfo(vehicle)}</strong>
            <span className='d-block fs-sub mt-2'>
              <span className='fw-600'>Services: </span>
              <span>{getServiceLines(vehicle)}</span>
            </span>
            <span className='d-block fs-sub'>
              <span className='fw-600'>STOCK/RO: </span>
              <span>{stock || 'None Added'}</span>
            </span>
            <span className='d-block fs-sub'>
              <span className='fw-600'>VIN: </span>
              <span>{vin || 'None Added'}</span>
            </span>
          </div>
        </div>
        {/* <div className='text-center'>
          <Button variant='default' className='text-primary text-uppercase fw-bold mx-auto'>View insurance supplement</Button>
        </div> */}

        {/* services */}
        <ServicesMobile serviceLines={serviceLines} />

        {/* photos */}
        <PhotosMobile onShowPhoto={onShowPhoto} vehicle={vehicle} />
      </div>
    </div>
  )
}

export default ViewMobile
